import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { Store } from '@ngxs/store'
import { UserState } from '../state-man/state/user.state'

const isSignedIn = () => !!inject(Store).selectSnapshot(UserState.getUser)?.is_logged_in

/** On 'tabs': a signed-out user goes to /login. */
export const signedIn: CanActivateFn = () => {
  const router = inject(Router)
  return isSignedIn() || router.parseUrl('/login')
}

/** On 'login' and 'login-verify': a signed-in user (after browser back, say) goes to the Schedule. */
export const signedOut: CanActivateFn = () => {
  const router = inject(Router)
  return !isSignedIn() || router.parseUrl('/tabs/schedule')
}
